import { ValidatorFn, FormGroup, ValidationErrors, Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import { Directive } from "@angular/core";

/** The check-out can't take place before the check-in */
export const isDateAfterValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const startDate = control.get('startDate');
    const endDate = control.get('endDate');
    
    return (startDate && endDate && endDate.value && startDate.value >= endDate.value) ? { 'payIsDateAfter': true } : null;
};

@Directive({
    selector: '[payIsDateAfter]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IsDateAfterValidatorDirective, multi: true }]
})
export class IsDateAfterValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return isDateAfterValidator(control)
  }
}


// WEBPACK FOOTER //
// ./src/directives/is-date-after-valitator.directive.ts